import { IModalidade } from "interfaces/eventos";
import fieldFormModalidade from "./fieldModalidade";

const { id, icone, tipo } = fieldFormModalidade;

const initialValuesFormModalidade = (modalidade: IModalidade | null) => {
  return {
    [id.name]: modalidade?.id ?? "",
    [icone.name]: modalidade?.icone ?? "",
    [tipo.name]: modalidade?.tipo ?? "",
  };
};

export { initialValuesFormModalidade };
